import * as types from '../action.types';

export const initialState = [];

const MutatedDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.APPLY_CONVERSION:
      return [...action.payload];
    case types.RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default MutatedDataReducer;
